export default "__VITE_ASSET__BOEO7gCx__"